import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const VehicleCategorizationReportModule = new Module({
  id: 'vehicle-categorization-report',
  name: 'Vehicle Categorization Report',
  path: 'vehicle-categorization',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/VehicleCategorization'))
  )
});
